import { withPrefix } from 'gatsby';

export const trackCustomEvent = ({
  category,
  action,
  label,
  value,
}: {
  category: string;
  action: string;
  label: string;
  value: string;
}): void => {
  if (window.gtag) {
    window.gtag('event', action, {
      category,
      label,
      value,
    });
  }
};

export const isPageSelected = (path: string, pathname: string): boolean => {
  const [a, b] = [withPrefix(path), pathname].map(string =>
    string.replace(/\/$/, ''),
  );
  return a === b;
};

export const inRange = (value: number, min: number, max: number): boolean => {
  return value > min && value <= max;
};
